import { memo } from "react";

import { Finding } from "stores/FindingStore";

import ErrantShare from "./Finding/ErrantShare";
import Unknown from "./Finding/Unknown";

// -----------------------------------------------------------------------------

const FindingComponent: { [prop: string]: Function | null } = {
  BOX_ERRANT_SHARE: ErrantShare,
};

// -----------------------------------------------------------------------------

const BoxFindingDetails = memo(function BoxFindingDetails({
  finding,
}: BoxFindingDetailsProps): JSX.Element {
  const Component = FindingComponent[finding.name] ?? Unknown;

  return <Component finding={finding} />;
});

export default BoxFindingDetails;

// -----------------------------------------------------------------------------

interface BoxFindingDetailsProps {
  finding: Finding;
}
